import React, { useEffect } from "react";

import Modal from "react-bootstrap/Modal";

import DeviceForm from "./DeviceForm";

interface props {
	fetchData: any;
	device: any;
	dispatch: any;
	setDeviceModalVisibility: any;
	visibility: boolean;
}

const DeviceFormModal: React.FC<props> = ({
	fetchData,
	device,
	setDeviceModalVisibility,
	dispatch,
	visibility,
}) => {
	useEffect(() => {
		dispatch(setDeviceModalVisibility(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleClose = () => dispatch(setDeviceModalVisibility(false));

	return (
		<>
			<Modal
				show={visibility}
				onHide={() => handleClose()}
				className="modal-mobi"
			>
				<Modal.Header closeButton>
					<Modal.Title>Edit Device Properties</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<DeviceForm
						device={device}
						fetchData={fetchData}
					/>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default DeviceFormModal;
